/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export default {
	width: '100vw',
	left: '50%',
	right: '50%',
	marginLeft: '-50vw',
	marginRight: '-50vw',

	img: {
		position: 'absolute',
	},
} as SxProps;
